import { CSSProperties, JSX, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { VIEW_LEGEND_ITEM_BOTTOM_MARGIN } from './consts';
import { COLORSWATCH_SIZE, ColorSwatch } from '@ardoq/graph';
import { ViewLegendItemLabel } from './ViewLegendItemLabel';
import { colors } from '@ardoq/design-tokens';
import { Icon, IconName, IconSize } from '@ardoq/icons';

// TODO: extract global const
const BASE_TRANSITION_MS = 300;

const LegendItemContainer = styled.div<{
  $highlightOnHover: boolean;
  $isSelected: boolean;
}>`
  display: flex;
  align-items: center;
  padding: 2px 0;
  line-height: 20px;
  border-radius: 4px;
  transition: background-color ${BASE_TRANSITION_MS}ms ease-in-out;
  &:not(:last-child) {
    margin-bottom: ${VIEW_LEGEND_ITEM_BOTTOM_MARGIN};
  }

  .forExport & {
    flex: 1 0 100%;
  }
  ${({ $highlightOnHover, $isSelected }) =>
    $isSelected
      ? css`
          cursor: pointer;
          background-color: ${colors.grey200};
        `
      : $highlightOnHover &&
        css`
          cursor: pointer;
          &:hover {
            background-color: ${colors.grey50};
          }
        `}
`;

const RightJustifiedIcon = styled(Icon)`
  margin-left: auto;
`;

interface LegendItemArgs {
  color?: string;
  description?: string | ReactNode;
  descriptionText?: string;
  getShape?: (size: number) => JSX.Element;
  style?: CSSProperties;
  borderColor?: string;
  onMouseOver?: VoidFunction;
  onMouseOut?: VoidFunction;
  isSelected?: boolean;
  isSelectable?: boolean;
  setSelected?: (isSelected: boolean) => void;
  itemClickTrackingFunction?: () => void;
}
const LegendItem = ({
  color: backgroundColor,
  description,
  descriptionText,
  getShape,
  style,
  borderColor,
  onMouseOver,
  onMouseOut,
  isSelected,
  isSelectable,
  setSelected,
  itemClickTrackingFunction,
}: LegendItemArgs) => {
  const border = borderColor ? `1px solid ${borderColor}` : undefined;
  return (
    <LegendItemContainer
      style={style}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onClick={
        isSelectable
          ? () => {
              setSelected?.(!isSelected);
              itemClickTrackingFunction?.();
            }
          : undefined
      }
      $isSelected={Boolean(isSelected)}
      $highlightOnHover={Boolean(onMouseOver)}
    >
      {getShape?.(COLORSWATCH_SIZE) || (
        <ColorSwatch style={{ backgroundColor, border }} />
      )}
      {description ? (
        <ViewLegendItemLabel textContent={descriptionText}>
          {description}
        </ViewLegendItemLabel>
      ) : null}
      {isSelected && (
        <RightJustifiedIcon
          iconName={IconName.CHECK_MARK}
          iconSize={IconSize.SMALL}
        />
      )}
    </LegendItemContainer>
  );
};

export { LegendItem };
